// extracted by mini-css-extract-plugin
module.exports = {"twoSideLayout":"TwoSideLayout_twoSideLayout__8jkl6","article":"TwoSideLayout_article__beadT","aside":"TwoSideLayout_aside__4BDpQ"};